import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyOrdersComponent } from '@app/my-orders/my-orders.component';

/**
 * routes
 * @type {({path: string; component: MyCollectionComponent; pathMatch: string} | {path: string; redirectTo: string})[]}
 */
const routes: Routes = [
  { path: '', component: MyOrdersComponent, pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

/**
 * MyCollectionRoutingModule
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyOrdersRoutingModule {}
